import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm,
} from 'antd';

import { asyncGet, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import { delect, delectAll } from './reducers';

class AppList extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.id);
    }

    handleDelete = async record => {
        record.deleteFlag = '1';
        await this.props.delect(record);
        this.props.asyncGet();
    }

    renderAction = (text, record) => {
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.edit(record); }} >
                    编辑
                </Button>

                <Popconfirm title="是否删除?" onConfirm={() => { this.handleDelete(record); }} >
                    <Button type="primary" style={{ marginRight: '5px' }} size="small">
                        < a href="#">删除</a>
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    onSelectChange = (selectedRowKeys, selectedRows) => { //selectedRowKeys  指定选中项的 key 数组
        this.props.getTransferData({ selectedRowKeys });
        this.props.getSele(selectedRowKeys);
    }

    render() {
        let { list, uiStatus, pagination, transferData } = this.props;
        const { selectedRowKeys } = transferData;
        let { isLoading } = uiStatus;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const columns = [
            {
                title: 'appId',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'app名称',
                dataIndex: 'appName',
                key: 'appName',
            },
            {
                title: '包名称',
                dataIndex: 'packageName',
                key: 'packageName',
            },
            {
                title: '版本',
                dataIndex: 'version',
                key: 'version',
            },
            {
                title: 'url',
                dataIndex: 'url',
                key: 'url',
            },
            {
                title: 'channel',
                dataIndex: 'channel',
                key: 'channel',
            },
            {
                title: 'used',
                dataIndex: 'used',
                key: 'used',
                render: (text, record, index) => {
                    if(text==0){
                        return "未使用"
                    }else{
                        return "已使用";
                    }
                }
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={{
                            ...pagination,
                        }}
                        defaultExpandAllRows={false}
                        onChange={this.changeHandle}
                      /*  rowSelection={rowSelection}*/
                    />
                    <Edit />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.appList.list,
    pagination: state.appList.pagination,
    uiStatus: state.appList.uiStatus,
    transferData: state.appList.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delect: record => dispatch(delect(record)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
    getSele: data => dispatch(actions.getSele(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AppList);



// WEBPACK FOOTER //
// ./pages/client/AppList/index.js